import React, { useEffect, useRef, useState } from 'react';
import { Box, Grid } from '@mui/material';
import { TableComponents, SimpleDialog, ExportButton, FilterPod } from 'components';
import { enifyDateTime } from 'utility';
import { useCommon, useCommonDispatcher, useExportFile } from 'hooks';
import { toFilterVOS } from 'components/FilterPod';
import { useNavigate } from 'react-router-dom';
import { columns } from './Columns';
import { reportFactorsCreditor } from '../../services/DetailAccountsServices';
import generateData from './generateData';
import SharePaymentLinkDialog from './SharePaymentLinkDialog';
import PaymentWithCreditDialog from './PaymentWithCreditDialog';
import MessageCartableDg from './MessageCartableDg';
import useCustomHook from '../hooks';
import { animateScroll as scroll } from 'react-scroll';
import FilterButton from 'components/FilterPod/FilterButton';
import { getDynamicObjectAction } from 'utility';
import axios from 'axios';
import { getExport1497Url } from 'URLs';
import { useCurrencyUnit } from 'hooks';

const Content = () => {
  // -- STATES --//
  const {
    filters,
    setFilters,
    size,
    setSize,
    page, setPage,
    filterParams,
    setFilterParams,
    isPaymentLinkOpen,
    setIsPaymentLinkOpen,
    selectedInvoice,
    setSelectedInvoice,
    isOpenDialog,
    setIsOpenDialog,
    isOpenMessageCartableDg, setIsOpenMessageCartableDg,
    requestId, setRequestId,
    loading, setLoading,
  } = useCustomHook();

  // -- HOOKS --//
  const { downloadFile, isExporting } = useExportFile({
    url: getExport1497Url(),
    filename: 'invoice-creditor',
  });
  const currencyText = useCurrencyUnit(false);

  const actionsList = getDynamicObjectAction([
    'invoiceCreditorFinancialPage',
    'exportinvoiceCreditorFinancialBtn',
    'invoiceCreditorDetailFinancialPage',
    'paymentLinkInvoiceCreditorFinancialBtn',
    'paymentInvoiceCreditorFinancialBtn',
  ]);
  const [openFilterDialog, setOpenFilterDialog] = useState(false);
  const handleCloseFilterDialog = () => setOpenFilterDialog(false);

  const setDialog = useCommonDispatcher();
  const dialog = useCommon();
  const tableRef = useRef();

  const navigate = useNavigate();

  // -- API REQUESTS --//
  const getList = async (query) => {
    setLoading(true)
    try {
      let orderBy = [];
      let orderByName = null;
      const filter = toFilterVOS([...filters]);
      const params = {
        page: query ? query?.pageNumber : page,
        size: query ? query?.pageSize : size,
      };

      // ordering
      switch (query?.orderBy?.title) {
        case 'تاریخ و زمان صدور':
          orderBy = [
            {
              name: 'تاریخ صدور',
              isDesc: query?.orderDirection === 'desc',
            },
            {
              name: 'زمان صدور',
              isDesc: query?.orderDirection === 'desc',
            },
          ];
          break;
        case 'تاریخ و زمان پرداخت':
          orderBy = [
            {
              name: 'تاریخ پرداخت',
              isDesc: query?.orderDirection === 'desc',
            },
            {
              name: 'زمان پرداخت',
              isDesc: query?.orderDirection === 'desc',
            },
          ];
          break;

        case `مالیات (${currencyText})`:
          orderByName = 'مالیات';
          break;
        case`مبلغ قابل پرداخت (${currencyText})`:
          orderByName = 'مبلغ قابل پرداخت';
          break;
        default:
          orderByName = query?.orderBy?.title;
          break;
      }
      if (orderByName && orderBy.length === 0) {
        orderBy = [
          {
            name: orderByName,
            isDesc: query?.orderDirection === 'desc',
          },
        ];
      }
      // end ordering

      const data = {
        filterVOS: filter ?? [],
        orderByElementVOS: orderBy ?? [],
        parentParams: [
          {
            key: 'START_DATE',
            value: enifyDateTime(filters[0]?.value?.start?.format('jYYYY/jMM/jDD HH:mm:ss')),
          },
          {
            key: 'END_DATE',
            value: enifyDateTime(filters[0]?.value?.end?.format('jYYYY/jMM/jDD HH:mm:ss')),
          },
        ],
      };

      setFilterParams({ data, params });

      const res = await reportFactorsCreditor(data, params);

      let list = [];
      if (res.result) {
        list = generateData(res.result, {
          page: query ? query?.pageNumber : page,
          pageSize: query ? query?.pageSize : page,
        });
      }
      setLoading(false)
      return {
        data: list,
        page: query ? query?.pageNumber : page,
        totalCount: res.result.totalCount,
      };
    } catch (error) {
      if (axios.isCancel(error)) {
        setLoading(true);
      } else {
        setLoading(false)
        return {
          data: [],
          page: query ? query?.pageNumber : page,
          totalCount: 0,
        };
      }
    }
  };
  // -- OTHER FUNCTIONS --//
  const onFiltersChange = (newFilters) => {
    setFilters(newFilters);
    setPage(0)
    setSize(10)
    setTimeout(() => {
      tableRef?.current?.onChangeTable(true);
    }, 100)
  };

  const onExport = (type, index) => {
    const types = ['xls', 'csv'];
    downloadFile(types[index], filterParams?.data, filterParams?.params);
  };

  const handleCloseDialog = () => {
    setDialog({ title: '', content: '', open: false });
  };

  useEffect(() => {
    !isOpenMessageCartableDg && setRequestId(null);
  }, [isOpenMessageCartableDg])


  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          <Box display="flex" justifyContent='end' alignItems="flex-end" style={{ marginBottom: 16 }}>
            {actionsList['invoiceCreditorFinancialPage'] && (
              <FilterButton
                setOpenFilterDialog={setOpenFilterDialog}
                filters={filters}
              />
            )}
            {actionsList['exportinvoiceCreditorFinancialBtn'] && (
              <ExportButton
                loading={isExporting}
                types={['xls', 'csv']}
                onExport={onExport}
              />
            )}
          </Box>
          {actionsList['invoiceCreditorFinancialPage'] && (
            <Box>
              <FilterPod
                filters={filters}
                onChange={onFiltersChange}
                openFilterDialog={openFilterDialog}
                setOpenFilterDialog={setOpenFilterDialog}
                handleCloseFilterDialog={handleCloseFilterDialog}
              />
            </Box>
          )}
        </Grid>
        {actionsList['invoiceCreditorFinancialPage'] &&  currencyText &&(
          <Grid item xs={12}>
            <TableComponents
              data={getList}
              columns={columns(
                actionsList,
                setSelectedInvoice,
                setIsPaymentLinkOpen,
                setIsOpenDialog,
                currencyText,
              )}
              isLoading={loading}
              ref={tableRef}
              onChange={(ps) => {
                setPage(ps?.pageNumber)
                setSize(ps?.pageSize)
                return getList(ps)
              }}
            />
          </Grid>
        )}
      </Grid>
      <SimpleDialog
        fullWidth
        maxWidth="lg"
        open={dialog?.open || false}
        title={dialog?.title}
        onClose={handleCloseDialog}
        loading={dialog?.loading || false}
      >
        {dialog?.content}
      </SimpleDialog>
      <SharePaymentLinkDialog
        invoice={selectedInvoice}
        open={isPaymentLinkOpen}
        setOpen={setIsPaymentLinkOpen}
      />
      <PaymentWithCreditDialog
        invoice={selectedInvoice}
        open={isOpenDialog}
        setOpen={setIsOpenDialog}
        tableRef={tableRef}
        setRequestId={setRequestId}
        setIsOpenMessageCartableDg={setIsOpenMessageCartableDg}
      />
      {/* اگر از نوع کارتابلی باشد و بعد از پرداخت دیالوگ جزییات نمایش داده میشود و دکمه تایید به صفحه جزییات کارتابل منتقل میشود */}
      <MessageCartableDg
        isOpenDg={isOpenMessageCartableDg}
        setIsOpenDg={setIsOpenMessageCartableDg}
        requestId={requestId}
        navigate={navigate}
        scroll={scroll}
      />
    </>
  );
};

export default Content;
